module.exports = __webpack_public_path__ + "img/texto_preto.87221d14.png";